import React from 'react';
import { NamingJsonStore, TitleContentLayout } from '@zen/common-app-parts';
import { truncateOrNameAsset } from '@zen/common-utils/lib/utils/assetUtils';
import useContract from '../../hooks/useContract';
import TopParagraph from '../TopParagraph/TopParagraph';

export default function FPLayout({ title, children, link }) {
  const { address, id } = useContract();
  const { state: naming } = NamingJsonStore.useStore();
  const name = !!naming && naming[id] ? naming[id].name : truncateOrNameAsset(id);
  return (
    <TitleContentLayout
      title={title}
      renderBelowTitle={<TopParagraph link={link} address={address} name={name} />}
    >
      {children}
    </TitleContentLayout>
  );
}
